import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

export const getWorkOrderForms = async ({ completeNotBeforeDate } = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-forms`, {
      params: { completeNotBeforeDate },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching work-order-forms:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getWorkOrderFormById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching work-order-form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const createWorkOrderForm = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/work-order-forms`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating work-order-form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const updateWorkOrderForm = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/work-order-forms/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating work-order-form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const deleteWorkOrderForm = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/work-order-forms/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting work-order-form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const checkFormExists = async (formId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/check-form-exists`,
      { params: { formId } },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error checking work-order-form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getWorkOrderFormsByWorkOrderId = async (workOrderId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-forms`, {
      params: { workOrderId },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching work-order-forms by WO:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getWorkOrderFormsByWorkOrderIds = async (workOrderIds = []) => {
  if (!workOrderIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/by-work-order-ids`,
      {
        params: { workOrderIds: workOrderIds.join(",") },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching work-order-forms by WO IDs:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getPaginatedForms = async ({
  page = 1,
  pageSize = 25,
  search = "",
  assetId,
  areaId,
  departmentId,
  userId,
  updatedByUserId,
  formTypeId,
  completed,
  completedUserId,
  completedContractorId,
  assignUserId,
  assignedContractorId,
  updatedAt,
  assigned,
  inProgress,
  sortField,
  sortOrder,
}) => {
  const response = await axiosInstance.get(
    `${API_URL}/work-order-forms/paginated`,
    {
      params: {
        page,
        pageSize,
        search,
        assetId,
        areaId,
        departmentId,
        userId,
        updatedByUserId,
        formTypeId,
        completed,
        completedUserId,
        completedContractorId,
        assignUserId,
        assignedContractorId,
        updatedAt,
        assigned,
        inProgress,
        sortField,
        sortOrder,
      },
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value
              .filter((v) => v !== undefined && v !== null && v !== "")
              .forEach((v) => query.append(key, String(v))); // force string
          } else if (value !== undefined && value !== null && value !== "") {
            query.append(key, String(value)); // <-- "0" not dropped
          }
        });
        return query.toString();
      },
    },
  );
  return response.data;
};

export const getFormsDashboardSummary = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/dashboard-summary`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching forms dashboard summary:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getFormsByTypeSummary = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/form-type-summary`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching forms by type summary:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getTopCompletedFormsByFormId = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/top-completed-by-form`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching top completed forms by form:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getFormsMonthlyStats = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-forms/monthly-stats`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching forms monthly stats:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const generateWorkOrderFormPdf = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/work-order-forms/${id}/pdf`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error generating work-order-form PDF:",
      error.response?.data || error,
    );
    throw error;
  }
};
